import React from 'react'
import {SvgIcon, SvgIconProps} from '@mui/material'

const screenerSvg = (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M31.2681 31.2987L40 40M12.0779 29.2208C15.0449 25.81 19.7402 20.4546 19.7402 20.4546L24.2532 24.9675L37.3052 10M34.4378 18.9816C35.2683 21.8334 35.0533 24.888 33.8317 27.5954C32.61 30.3028 30.4618 32.4852 27.774 33.7494C25.0862 35.0136 22.0354 35.2767 19.1708 34.4913C16.3062 33.7059 13.8162 31.9236 12.149 29.4653C10.4819 27.007 9.74717 24.0342 10.0772 21.0823C10.4072 18.1304 11.7803 15.3933 13.9491 13.3639C16.118 11.3345 18.9402 10.146 21.9074 10.0126C24.8747 9.87916 27.7922 10.8095 30.1344 12.6361"
            stroke="currentColor" strokeLinecap="round"/>
    </svg>


)

const Screener: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {screenerSvg}
    </SvgIcon>
)

export default Screener